export default __webpack_public_path__ + "static/media/books.1a571e3b.PNG";